import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Select, message, Button, Tabs } from "antd";
import { getAllISOCodes } from "iso-country-currency";
import { default as ReactSelect } from "react-select";
import { signupCompany, signupUser } from "../../api/api";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import { useTheme } from "../../utils/themeToggle/theme";

const { Option } = Select;

export default function CompanyOnboardModal({ open, onClose }) {
  const [form] = Form.useForm();
  const [userForm] = Form.useForm(); // separate form for user
  const [isLoading, setIsLoading] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState("+91");
  const [allCurrency, setAllCurrency] = useState([]);
  const user_id = useSelector((store) => store.auth.userInfo.user_id);
  const { reactSelectTheme } = useTheme();
  const [userType, setUserType] = useState("onboard"); // "onboard" or "user"
  const token = useSelector((state) => state.auth.accessToken);

  const onFinishUser = async (values) => {
    console.log(values, "User Form Values");
    // values.department = 68;
    values.role = values.role.value;

    try {
      setLoadingUser(true);
      const { res } = await signupUser({
        // department: values.department,
        email: values.email,
        employee_id: values.employee_id,
        role: values.role,
        first_name: values.first_name,
        user_type: "professional",
      },token);

      if (res.status === 201) {
        message.success("User created successfully.");
        form.resetFields();
        form.setFieldsValue({
          department: { value: "Professional Legal", label: "Professional Legal" },
        });
      } else {
        message.error(res);
      }
    } catch (err) {
      message.error(err.error || "Failed to create user");
    } finally {
      setLoadingUser(false);
    }
  };

  const handleCountryChange = (countryId) => {
    const selected = countries.find((c) => c.id === countryId);
    setCountryCode(selected?.country_code || "+91");
  };

  const onFinish = async (values) => {
    const address = {
      country: parseInt(values.country),
    };

    try {
      setIsLoading(true);
      console.log(values, "Form Values");
      const { res } = await signupCompany({
        name: values.companyName,
        admin_email: values.email,
        admin_contact_number: values.phone,
        first_name: values.userName,
        address,
        currency: values.currency.label,
        profeshnal_id: user_id,
      });

      if (res.status === 201) {
        message.success("Company onboarded successfully!");
        onClose(); // close modal
        form.resetFields();
      } else {
        message.error(res || "Signup failed");
      }
    } catch (err) {
      message.error(err?.error || "Signup failed.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await axiosInstance.get(`/country/get/`);
        setCountries(res.data);
      } catch (error) {
        console.error("Failed to load countries");
      }
    };

    const fetchCurrency = async () => {
      try {
        const codes = await getAllISOCodes();
        const options = codes.map((code) => ({
          value: `${code.countryName} (${code.symbol})`,
          label: `${code.countryName} (${code.symbol})`,
        }));
        console.log("Currency Options:", options);
        setAllCurrency(options);
      } catch (error) {
        console.error("Currency fetch failed");
      }
    };

    fetchCountry();
    fetchCurrency();

    userForm.setFieldsValue({
      department: { value: "Professional Legal", label: "Professional Legal" },
    });
  }, []);


  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      title={<div className="text-lg font-semibold">Onboard New Company / Add User</div>}
      width={600}
    >

      <div className="flex mb-4">
        <button
          onClick={() => setUserType("onboard")}
          className={`px-4  rounded-tl-lg rounded-tr-lg py-2 w-1/2 shadow-md font-medium ${userType === "onboard"
            ? " bg-white border  border-gray-200 text-[#122253] dark:bg-[#17153B] dark:text-white shadow-lg"
            : "bg-gray-100 dark:bg-[#17153B]"
            }`}
        >
          Onboard Company
        </button>
        <button
          onClick={() => setUserType("user")}
          className={`px-4  rounded-tl-lg rounded-tr-lg py-2 w-1/2 shadow-md font-medium ${userType === "user"
            ? " bg-white border  border-gray-200 text-[#122253] dark:bg-[#17153B] dark:text-white shadow-lg"
            : "bg-gray-100 dark:bg-[#17153B]"
            }`}
        >
          Add User
        </button>
      </div>

      <div className="p-2 h-[430px] overflow-y-auto">

        {userType === "onboard" ? (
          <Form layout="vertical" form={form} onFinish={onFinish}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Form.Item
                name="userName"
                label="User Name"
                rules={[{ required: true, message: "Enter user name" }]}
              >
                <Input placeholder="Enter user name" />
              </Form.Item>

              <Form.Item
                name="companyName"
                label="Company Name"
                rules={[{ required: true, message: "Enter company name" }]}
              >
                <Input placeholder="Enter company name" />
              </Form.Item>

              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: "Enter valid email" }]}
              >
                <Input type="email" placeholder="Enter email" />
              </Form.Item>

              <Form.Item
                name="country"
                label="Country"
                rules={[{ required: true, message: "Select country" }]}
              >
                <Select
                  showSearch
                  placeholder="Select country"
                  onChange={handleCountryChange}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {countries.map((c) => (
                    <Option key={c.id} value={c.id}>
                      {c.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>


              <Form.Item
                name="currency"
                label="Base Currency"
                className="w-full"
                rules={[{ required: true, message: "Please select currency" }]}
              >
                <ReactSelect
                  options={allCurrency}
                  styles={reactSelectTheme}
                />
              </Form.Item>

              <Form.Item
                name="phone"
                label="Phone Number"
                rules={[{ required: true, message: "Enter phone number" }]}
              >
                <Input addonBefore={countryCode} placeholder="Enter number" />
              </Form.Item>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                className="w-full bg-[#122253] hover:bg-[#1b2a70]"
              >
                {isLoading ? "Submitting..." : "Create Company"}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Form
            form={userForm}
            layout="vertical"
            onFinish={onFinishUser}
            initialValues={{
              department: "Professional Legal", 
            }}
          >
            <Form.Item
              label="User Name"
              name="first_name"
              rules={[{ required: true, message: "Please enter your username" }]}
            >
              <Input placeholder="Enter your username" />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                { required: true, message: "Please enter your email address" },
                { type: "email", message: "Please enter a valid email address" },
              ]}
            >
              <Input type="email" placeholder="Enter your email address" />
            </Form.Item>

            <Form.Item name="employee_id" label="Employee ID">
              <Input placeholder="Please enter employee Id" />
            </Form.Item>
            <Form.Item
              name="role"
              label="Role"
              rules={[{ required: true, message: "Please select a Role" }]}
              getValueFromEvent={(option) => option}
            >
              <ReactSelect
                options={[
                  { value: "Professional Agreement controller Head", label: "Professional Agreement Control Head" },
                  { value: "Professional Agreement controller Team", label: "Professional Agreement Control Team" },
                ]}
                styles={reactSelectTheme}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingUser}
                className="w-full bg-[#122253] hover:bg-[#1b2a70]"
              >
                {loadingUser ? "Saving..." : "Save User"}
              </Button>
            </Form.Item>
          </Form>

        )}
      </div>

    </Modal>
  );
}
